import React from 'react';
export function Garantia() {
  return <section className="bg-offWhite px-5 py-10 md:py-[60px] text-center" data-id="element-95">
      <div className="mx-auto max-w-[600px] rounded-2xl border-2 border-navy bg-white p-6 md:p-[44px_36px] shadow-[0_4px_32px_rgba(0,0,0,0.07)]" data-id="element-96">
        <div className="mb-4 text-[52px]" data-id="element-97">🛡️</div>
        <h2 className="mb-3 font-bebas text-[38px] text-navy" data-id="element-98">
          7 Días de Garantía Total
        </h2>
        <p className="mb-2 text-[15px] leading-relaxed text-brandGray" data-id="element-99">
          Abrís los tomos, usás los bonos en tu consultorio. Si no es lo que
          esperabas: sin preguntas, sin formularios, sin drama.
        </p>
        <p className="mb-2 text-[15px] leading-relaxed text-brandGray" data-id="element-100">
          Te devolvemos el 100% del dinero en menos de 24 horas.
        </p>
        <p className="mt-4 font-montserrat text-[13px] font-bold text-navy" data-id="element-101">
          (Tasa de devoluciones &lt; 1%)
        </p>
      </div>
    </section>;
}